import {
  UPDATE_EDIT_VALUE,
  UPDATE_SELECT_PARTNER_SITE,
  UPDATE_SEARCH_VALUE,
  CLEAR_PARTNER_SITE_LIST,
  CLEAR_EDIT_VALUE,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  CHANGE_PARTNER_SITE_ENABLE,
  CHANGE_EDIT_VALUE,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_PARTNER_SITE_LIST,
  FETCH_PARTNER_SITES,
  FETCH_PARTNER_SITES_START,
  FETCH_PARTNER_SITES_SUCCESS,
  FETCH_PARTNER_SITES_ERROR,
  POST_PARTNER_SITE,
  POST_PARTNER_SITE_START,
  POST_PARTNER_SITE_SUCCESS,
  POST_PARTNER_SITE_ERROR,
  DELETE_PARTNER_SITE,
  DELETE_PARTNER_SITE_START,
  DELETE_PARTNER_SITE_SUCCESS,
  DELETE_PARTNER_SITE_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clearPartnerSiteList = () => ({ type: CLEAR_PARTNER_SITE_LIST })
const clearEditValue = () => ({ type: CLEAR_EDIT_VALUE })
const changeSearchValue = (value) => ({ type: CHANGE_SEARCH_VALUE, value })
const changePageSize = (size) => ({ type: CHANGE_PAGE_SIZE, size })
const changePartnerSiteEnable = (value) => ({ type: CHANGE_PARTNER_SITE_ENABLE, value })
const changeEditValue = (value) => ({ type: CHANGE_EDIT_VALUE, value })
const updateSelectPartnerSite = (id) => ({ type: UPDATE_SELECT_PARTNER_SITE, id })
const updateSearchValue = (value) => ({ type: UPDATE_SEARCH_VALUE, value })
const updatePartnerSiteList = (partner_sites) => ({ type: UPDATE_PARTNER_SITE_LIST, partner_sites })
const updatePageSize = (size) => ({ type: UPDATE_PAGE_SIZE, size })
const updateCountSize = (count) => ({ type: UPDATE_COUNT_SIZE, count })
const updateCurrentPage = (page) => ({ type: UPDATE_CURRENT_PAGE, page })
const updateEditValue = (value) => ({ type: UPDATE_EDIT_VALUE, value })
const incrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: 1 })
const decrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: -1 })

/* Async Calls */
const fetchPartnerSites = () => ({ type: FETCH_PARTNER_SITES })
const fetchPartnerSitesStart = () => ({ type: FETCH_PARTNER_SITES_START })
const fetchPartnerSitesSuccess = () => ({ type: FETCH_PARTNER_SITES_SUCCESS })
const fetchPartnerSitesError = (error) => ({ type: FETCH_PARTNER_SITES_ERROR, error })
const startFetchPartnerSitesAsync = buildAsyncAction(
  FETCH_PARTNER_SITES,
  FETCH_PARTNER_SITES_START,
  [FETCH_PARTNER_SITES_SUCCESS, FETCH_PARTNER_SITES_ERROR]
)

const postPartnerSite = (value) => ({ type: POST_PARTNER_SITE, value })
const postPartnerSiteStart = () => ({ type: POST_PARTNER_SITE_START })
const postPartnerSiteSuccess = () => ({ type: POST_PARTNER_SITE_SUCCESS })
const postPartnerSiteError = (error) => ({ type: POST_PARTNER_SITE_ERROR, error })
const startPostPartnerSiteAsync = buildAsyncAction(
  POST_PARTNER_SITE,
  POST_PARTNER_SITE_START,
  [POST_PARTNER_SITE_SUCCESS, POST_PARTNER_SITE_ERROR]
)

const deletePartnerSite = (value) => ({ type: DELETE_PARTNER_SITE, value })
const deletePartnerSiteStart = () => ({ type: DELETE_PARTNER_SITE_START })
const deletePartnerSiteSuccess = () => ({ type: DELETE_PARTNER_SITE_SUCCESS })
const deletePartnerSiteError = (error) => ({ type: DELETE_PARTNER_SITE_ERROR, error })
const startDeletePartnerSiteAsync = buildAsyncAction(
  DELETE_PARTNER_SITE,
  DELETE_PARTNER_SITE_START,
  [DELETE_PARTNER_SITE_SUCCESS, DELETE_PARTNER_SITE_ERROR]
)

export {
  incrementPage,
  decrementPage,
  changePageSize,
  changeSearchValue,
  changePartnerSiteEnable,
  changeEditValue,
  updateSelectPartnerSite,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updatePartnerSiteList,
  updateSearchValue,
  updateEditValue,
  clearEditValue,
  clearPartnerSiteList,
  fetchPartnerSites,
  fetchPartnerSitesStart,
  fetchPartnerSitesSuccess,
  fetchPartnerSitesError,
  startFetchPartnerSitesAsync,
  postPartnerSite,
  postPartnerSiteStart,
  postPartnerSiteSuccess,
  postPartnerSiteError,
  startPostPartnerSiteAsync,
  deletePartnerSite,
  deletePartnerSiteStart,
  deletePartnerSiteSuccess,
  deletePartnerSiteError,
  startDeletePartnerSiteAsync,
}
